var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment_landing"},[_c('PlanSetting',{attrs:{"selectedTermProps":_vm.selectedTermProps,"selectedProductProps":_vm.selectedProductProps,"termProps":_vm.termProps,"productProps":_vm.productProps,"activeSyncProps":_vm.activeSyncProps}}),_c('FeatureAndBenefits'),_c('QuestionAndAnswer'),_c('ContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }